import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-32 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Korean%20manhwa%20panoramic%20illustration%2C%20dreamy%20fantasy%20landscape%20with%20floating%20islands%2C%20warm%20golden%20sunset%20light%2C%20soft%20pastel%20sky%2C%20colorful%20clouds%2C%20wide%20cinematic%20composition%2C%20atmospheric%20lighting%2C%20ethereal%20mood%2C%20clean%20artistic%20style&width=1920&height=900&seq=cta-bg-manga&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/50 to-primary-950/80" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-4xl md:text-6xl font-black font-heading text-background-50 tracking-tight">
          准备好开始阅读了吗？
        </h2>
        <p className="mt-6 text-lg text-background-50/70 max-w-xl mx-auto leading-relaxed">
          超过2000部韩国漫画等你来探索，完全免费，每日更新，即刻开启你的漫画之旅
        </p>
        <Link
          to="/category/lianai"
          className="mt-8 inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-background-50 text-primary-900 text-sm font-bold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer group"
        >
          开始免费阅读
          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-900 text-background-50 group-hover:translate-x-1 transition-transform duration-200">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}